import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import MultipleImagesPreview from './MultipleImagesPreview';
import MultipleImagesForm from './MultipleImagesForm';
import LoadingScene from '../../../../../Components/LensLoadingScene/LoadingScene';
import { ImageContext } from '../../../../../Context/ImagesContext';

function MultipleMediaSection() {
    const carouselMenu = useSelector((state) => state.lens.carouselMenu);

    const { postingImagesLoading } = useContext(ImageContext);

    return (
        <>
            {carouselMenu === 'preview' && <MultipleImagesPreview />}

            {
                carouselMenu === 'form' && 
                <>
                    {
                        postingImagesLoading ? 
                        <LoadingScene /> : 
                        <MultipleImagesForm />
                    }
                </>
            }
        </>
    );
}

export default MultipleMediaSection;
